import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/login/index.vue')
    },
    {
        path: '/',
        component: () => import('../layout/index.vue'),
        redirect: '/dashboard',
        children: [
            {
                path: 'dashboard',
                name: 'Dashboard',
                component: () => import('../views/dashboard/index.vue'),
                meta: { title: '仪表盘', icon: 'el-icon-menu', roles: ['admin', 'creator'] }
            },
            {
                path: 'works',
                name: 'Works',
                component: () => import('../views/works/index.vue'),
                meta: { title: '作品管理', icon: 'el-icon-document', roles: ['admin', 'creator'] }
            },
            {
                path: 'creators',
                name: 'Creators',
                component: () => import('../views/creators/index.vue'),
                meta: { title: '创作者管理', icon: 'el-icon-user', roles: ['admin'] }
            },
            {
                path: 'users',
                name: 'Users',
                component: () => import('../views/users/index.vue'),
                meta: { title: '用户管理', icon: 'el-icon-s-custom', roles: ['admin'] }
            },
            {
                path: 'comments',
                name: 'Comments',
                component: () => import('../views/interactions/comments.vue'),
                meta: { title: '评论管理', icon: 'el-icon-chat-dot-square', roles: ['admin', 'creator'] }
            },
            {
                path: 'bottles',
                name: 'Bottles',
                component: () => import('../views/interactions/bottles.vue'),
                meta: { title: '漂流瓶管理', icon: 'el-icon-message', roles: ['admin'] }
            },
            {
                path: 'themes',
                name: 'Themes',
                component: () => import('../views/themes/index.vue'),
                meta: { title: '主题与二维码管理', icon: 'el-icon-collection-tag', roles: ['admin', 'creator'] }
            },
            {
                path: 'settings',
                name: 'Settings',
                component: () => import('../views/settings/index.vue'),
                meta: { title: '系统设置', icon: 'el-icon-setting', roles: ['admin'] }
            },
            {
                path: 'faq',
                name: 'Faq',
                component: () => import('../views/settings/faq.vue'),
                meta: { title: '常见问题管理', icon: 'el-icon-question', roles: ['admin'] }
            },
            {
                path: 'mall-orders',
                name: 'MallOrders',
                component: () => import('../views/mall/orders.vue'),
                meta: { title: '兑换订单', icon: 'el-icon-tickets', roles: ['admin'] }
            },
            {
                path: 'mall-items',
                name: 'MallItems',
                component: () => import('../views/mall/items.vue'),
                meta: { title: '商城商品', icon: 'el-icon-goods', roles: ['admin'] }
            },
            {
                path: 'banners',
                name: 'Banners',
                component: () => import('../views/banners/index.vue'),
                meta: { title: '轮播图管理', icon: 'el-icon-picture', roles: ['admin'] }
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_ROUTER_BASE || process.env.BASE_URL,
    routes
})

// Route guard
router.beforeEach((to, from, next) => {
    const isLoggedIn = store.getters.isLoggedIn
    const currentUser = store.getters.currentUser
    const userRole = (currentUser.role || '').toLowerCase()
    const username = (currentUser.username || '').toLowerCase()

    console.log('[Router Guard] User:', currentUser)
    console.log('[Router Guard] Role:', userRole, 'Username:', username)

    if (to.path === '/login') {
        // If already logged in, redirect to dashboard
        if (isLoggedIn) {
            next({ path: '/dashboard' })
        } else {
            next()
        }
    } else {
        // Check if user is logged in
        if (isLoggedIn) {
            // Check role permission
            const requiredRoles = to.meta && to.meta.roles
            // admin 用户或 admin 角色都可以访问所有页面
            const isAdmin = userRole === 'admin' || username === 'admin'
            if (requiredRoles && !isAdmin && !requiredRoles.includes(userRole)) {
                // No permission, redirect to dashboard
                console.log('[Router Guard] Access denied, redirecting to dashboard')
                next({ path: '/dashboard' })
            } else {
                next()
            }
        } else {
            next({ path: '/login' })
        }
    }
})

export default router
